import { render, staticRenderFns } from "./TarjetaAdjunto.vue?vue&type=template&id=184574cd&scoped=true&"
import script from "./TarjetaAdjunto.vue?vue&type=script&lang=js&"
export * from "./TarjetaAdjunto.vue?vue&type=script&lang=js&"
import style0 from "./TarjetaAdjunto.vue?vue&type=style&index=0&id=184574cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184574cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VImg,
})
